import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token from localStorage as fallback (for environments where cookies are blocked)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("erpgo_session_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// When trial expired (HTTP 402), redirect to the upgrade page.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402 && err?.response?.data?.upgrade_path) {
      const upgrade = err.response.data.upgrade_path;
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/billing/upgrade")) {
        window.location.assign(upgrade);
      }
    }
    return Promise.reject(err);
  }
);

export default api;
